import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import AdminPage from 'modules/restaurant/admin/AdminPage';

export default function DashRestaurantAdmin() {
    return (
        <DashContainer title='Administração'>
            <AdminPage />
        </DashContainer>
    );
}
